module.exports = {"Type":"CheckVariable","Fields":[{"label":"Name of the variable","type":"multiline","name":"text","serializeTo":"q"}],"Header":{"Color":"white","BackgroundColor":"gray","Text":null}}


//////////////////
// WEBPACK FOOTER
// ./src/designer/widgets/CheckVariable.json
// module id = 688
// module chunks = 0